import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { PAGES } from "../constants/Pages";

const PrivateRoute = ({ children }) => {
  const isLogin = localStorage.getItem('ISLOGIN');
  return isLogin ? children : <Navigate to={`${PAGES.LOGIN}`} />;
};

export default PrivateRoute;
